import * as React from 'react'
import { type PropsWithChildren } from 'react'
import { TidalThemeProvider } from '@workwave-tidal/core/styles'
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles'

import { salesCenterLegacyTheme } from '@sales-center/common'
import { tidalTheme, useTidalThemeActive } from './features/TidalThemeToggle/'

export function SalesCenterThemeProvider(props: PropsWithChildren) {
  const { children } = props

  const tidalThemeActive = useTidalThemeActive()

  if (tidalThemeActive) {
    return (
      <TidalThemeProvider theme={tidalTheme}>{children}</TidalThemeProvider>
    )
  }

  return (
    <CssVarsProvider theme={salesCenterLegacyTheme}>{children}</CssVarsProvider>
  )
}
